/*******
Common Function Used In Diamond Listing & Detail Page 
********/

/*** Pre Define Constant Values For Webservice Call ***/
const api = "https://autumn.buildzone.net/live/graphql/";
const gemstoneListingApi = "gemstoneData";
const gemstoneDetailApi = "gemstoneById";
const gemstoneAddToCart = "gemstoneAddToCart";
/*** End ***/

/*** Store Language Code ***/
const store_lang = window.Shopify.locale;
/*** End ***/

/*** AddCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(gemstoneData) {
  var certificateFile = '';
  var gemLab = gemstoneData.lab;
  var gemCertNo = gemstoneData.certificateNumber;
  var gemCarat = gemstoneData.caratWeight;
  
  if(gemstoneData.certificateFile != ''){
    certificateFile = gemstoneData.certificateFile;
  }else{
    switch(gemLab)
      {
        case "GIA":
            certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+gemCertNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
            break;
        case "IGI":
            certificateFile = 'https://www.igi.org/verify-your-report/?r='+gemCertNo;
            break;
        case "HRD":
            certificcertificateFileateFile = 'https://my.hrdantwerp.com/?record_number='+gemCertNo+'&weight='+gemCarat;
            break;
        case "AGS":
            certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+gemCertNo+'&Weight='+gemCarat+'&D=1';
            break;
        default:
            certificateFile = "";
      }
  }    
  return certificateFile;
}
/*** End ***/

/*** Gemstone Broken Image Fixes start ***/ 
function imgError(image,defaultImage) {
  image.onerror = "";
  image.src = defaultImage;
  return true;
}
/*** End ***/  
function getGemstoneDefaultFinalPriceField(currencyCode){
  var diamond_price_field;
	switch (currencyCode) {		
		case "EUR":
			diamond_price_field = "finalPriceEur";
			break;
		case "GBP":
			diamond_price_field = "finalPriceGbp";
			break;
		case "USD":
			diamond_price_field = "finalPriceUsd";
			break;		
		default:
			diamond_price_field = "finalPriceGbp"
	}
	return diamond_price_field;
}
/*** End ***/
  
/*** Get Gemstone Price Start ***/
function getGemstonePrice(currencyRate,finalPrice) {  
  var final_gem_price = finalPrice * currencyRate; 
  var gem_formatted_price = Math.ceil(final_gem_price);      
  gem_formatted_price = Shopify.formatMoney(gem_formatted_price * 100, theme.moneyFormat);
  gem_formatted_price = gem_formatted_price.replace(/([.,])00$/, '');
  return gem_formatted_price;
}
/*** End ***/

/*** Get Gemstone Type Start ***/
function getDiamondType(diamondType) {
  var type = diamondType;
  if(type == 'white'){
    dia_type = 'Natural';
  }else{
    dia_type = type;
  }
  return dia_type;
}
/*** End ***/

/*** Get Gemstone Name Start ***/
function getGemstoneName(gemstoneData,diamondType) {
  var diamond_name = gemstoneData.caratWeight + " "+translations.titleCarat+" " + gemstoneData.shape + " "+translations.titleShape+" "+ diamondType +" "+translations.titleGemstone;
  return diamond_name;
}
/*** End ***/

/*** Get Gemstone measurement Start ***/
function getGemstoneMeasurement(gemstoneData) {
  console.log("gemstoneData",gemstoneData);
  if(gemstoneData.measurement != ''){
    var measurements = gemstoneData.measurement;
  }else{
    var measurements = gemstoneData.length + " * " + gemstoneData.width + " * " + gemstoneData.depth;
  }  
  console.log("measurements",measurements);
  return measurements;
}
/*** End ***/

/*** Get Gemstone Girdle Start ***/
function getGemstoneGirdle(gemstoneData) {
  if(gemstoneData.girdleMin != '' && gemstoneData.girdleMax != '' && gemstoneData.girdleMin != 0 && gemstoneData.girdleMax != 0){
    var girdle = gemstoneData.girdleMin+"-"+gemstoneData.girdleMax;
  }else if(gemstoneData.girdleMax == '' && gemstoneData.girdleMax == 0){
    var girdle = gemstoneData.girdleMin;
  }else if(gemstoneData.girdleMin == '' && gemstoneData.girdleMax == 0){
    var girdle = gemstoneData.girdleMax;
  }else{
    var girdle = 'NA';
  }  
  return girdle;
}
/*** End ***/

/*** Get Gemstone Detail Information Layout ***/
function getGemstoneInformationLayout(gemstoneData) {
  var gemstone_certificate_url = getCertificateUrl(gemstoneData);
  var gemstone_measurements = getGemstoneMeasurement(gemstoneData);

  //Dynamic Gemstone Information Array 
  var gemstoneInformation = {
    "gemstoneReportNo" : translations.titleReportNo+' - '+gemstoneData.certificateNumber,
    "gemstoneReport"  : translations.titleGradingReport+' - '+gemstoneData.lab+' - '+gemstone_certificate_url,
    "gemstoneShape"   : translations.titleShape+' - '+gemstoneData.shape,
    "gemstoneCarat"   : translations.titleCaratWeight+' - '+gemstoneData.caratWeight,
    //"gemstoneStockId" : translations.titleStockID+' - '+gemstoneData.stockNumber,    
    "gemstoneColor"   : translations.titleColor+' - '+gemstoneData.color,
    "gemstoneFancyColor" : translations.titleColor+' - '+gemstoneData.fancyColor,    
    "gemstoneClarity" : translations.titleClarity+' - '+gemstoneData.clarity,
    "gemstoneCut"     : translations.titleCut+' - '+gemstoneData.cut,    
    "gemstoneRatio"   : translations.titleRatio+' - '+gemstoneData.ratio,
    //"gemstoneMeasurement" : translations.titleMeasurement+' - '+gemstone_measurements,
    //"gemstoneOrigin" : translations.titleOrigin+' - '+gemstoneData.origin,
    "gemstoneTreatment"   : translations.titleTreatment+' - '+gemstoneData.treatment,
    // 
   
    //"gemstoneSymmetry": translations.titleSymmetry+' - '+gemstoneData.symmetry,
   // "gemstonePolish"  : translations.titlePolish+' - '+gemstoneData.polish,
   // "gemstoneGirdle"  : translations.titleGirdle+' - '+gemstoneData.girdle,
    //"gemstoneCulet"   : translations.titleCulet+' - '+gemstoneData.culet,
    //"gemstoneIntensity"  : translations.titleIntensity+' - '+gemstoneData.fancyColorIntensity,
   // "gemstoneOvartone"   : translations.titleOvertone+' - '+gemstoneData.fancyColorOvertone,
    //"gemstoneLength"   : translations.titleLength+' - '+gemstoneData.length,
    //"gemstoneWidth"   : translations.titleWidth+' - '+gemstoneData.width,
  };
  //end

  //Gemstone Information HTML Layout
  var detailInfo = '';
  if(gemstoneInformation != ''){
     var j = 1;
     $.each(gemstoneInformation, function(i, diamondInfo) {
       var diamondInfoArray = diamondInfo.split(" - ");
       if(diamondInfoArray.length > 1){
         var infoLable = diamondInfoArray[0];
         var infoValue = diamondInfoArray[1];
        
         if(diamondInfoArray[1] != ''){
           if(diamondInfoArray.length == 3){
             var infoUrl = diamondInfoArray[2];
             detailInfo += '<div class="detail-column-row-'+j+' tps-single-info">';
             detailInfo += '<span class="detail-row-1 tps-txt-title">'+infoLable+'</span>';
             detailInfo += '<span class="detail-row-2 tps-txt-info">';
             if(diamondInfoArray[1] != 'NONE' && diamondInfoArray[2] != ''){
               detailInfo += '<a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a>';
             }else{               
               if(diamondInfoArray[2] != ''){
                 detailInfo += '<a href="'+infoUrl+'" target="_blank" alt="Certificate URL" title="Certificate Title">'+infoValue+'</a>';
               }else{
                 infoValue = translations.titleReportNotAvailable;
                 detailInfo += infoValue;
               }               
             }
             
             detailInfo += '</span></div> ';
           }else{
             if(infoValue != 'null'){
               detailInfo += '<div class="detail-column-row-'+j+' tps-single-info"><span class="detail-row-1 tps-txt-title">'+infoLable+'</span><span class="detail-row-2 tps-txt-info">'+infoValue+'</span></div> ';
             }             
           } 
           j++;
         }
       }        
    });
  }
  //end
  
  return detailInfo;
}
/*** End ***/

/*** Config function forpre define module url start ***/
if(store_lang == 'de'){
  
}else{
  var tps_config = {
	"urls": {        
        "loose_gemstone": "/pages/loose-gemstones",
        "loose_gemstone_detail": "/pages/loose-gemstone-details",
	}

  }
}
/*** End ***/

/*** Show Product Detail & Final Ring Page Loader Start ***/
function showProductLoader(galleryStyle){
  if(galleryStyle == 'grid-view'){            
    if(jQuery(window).width() <= 767){
      jQuery(".tps-loader-horizontal-thumb-slider").show();
    }else{
      jQuery(".tps-loader-"+galleryStyle).show();
    }
  }else{
    jQuery(".tps-loader-"+galleryStyle).show();
  }
}
/*** Show Product Detail & Final Ring Page Loader End ***/

/*** Remove HTML Elements In Mobile ***/
function removeHtmlElementsInMobile() {  
  jQuery('.tps-mobile-hide').remove();	
}
/*** End ***/

/*** Remove HTML Elements In Desktop ***/
function removeHtmlElementsInDesktop() {
  jQuery('.tps-desktop-hide').remove();	
}
/*** End ***/

/*******
End
********/